import React from 'react';
import { useTranslation } from 'react-i18next';

import './HaatSteps.css';

const STEP_IMAGES = [
  'https://haatnexusprodinfosys.blob.core.windows.net/images/4.png',
  'https://haatnexusprodinfosys.blob.core.windows.net/images/3.png',
  'https://haatnexusprodinfosys.blob.core.windows.net/images/2.png',
  'https://haatnexusprodinfosys.blob.core.windows.net/images/1.png',
] as const;

const STEP_KEYS = ['step1', 'step2', 'step3', 'step4'] as const;

/**
 * Partner journey section — four steps from accepting orders to growing the
 * business. Copy is translated via i18n; layout follows document direction.
 */
const HaatSteps: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="haat-steps">
      <div className="wrap">
        <h2 className="title">{t('landingSections.steps.heading')}</h2>
        <div className="steps">
          {STEP_KEYS.map((stepKey, index) => {
            const imageSrc = STEP_IMAGES[index];

            return (
              <article key={stepKey} className="step">
                <div className="media">
                  <img
                    src={imageSrc}
                    alt={t(`landingSections.steps.${stepKey}.alt`) as string}
                  />
                </div>
                <h3>{t(`landingSections.steps.${stepKey}.title`)}</h3>
                <p>{t(`landingSections.steps.${stepKey}.desc`)}</p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HaatSteps;
